module.exports = __webpack_public_path__ + "media/images/athletes/1682-a9f30d0347f731267a9d85a88496edaf.png";